import type { ReactNode } from 'react'
import { isTourV2Offer } from 'lib/offer/offerTypes'
import { LUX_PLUS_MONTH_CAMPAIGN_ID } from 'takeovers/luxPlusMonthTakeover/constants/luxPlusMonthTakeoverConstants'
import LuxPlusMonthTakeoverCampaignTagLabel from 'takeovers/luxPlusMonthTakeover/components/LuxPlusMonthTakeoverCampaignTagLabel'
import LuxPlusMonthTakeoverDetailsModal from 'takeovers/luxPlusMonthTakeover/components/LuxPlusMonthTakeoverDetailsModal'
import LuxPlusMonthTakeoverToursBenefitModal from 'takeovers/luxPlusMonthTakeover/components/LuxPlusMonthTakeoverToursBenefitModal'

interface SiteTakeoverCampaignTagOverride {
  renderLabel: () => ReactNode
  // Optional: lets a campaign decide if/when the shared info icon should show and what modal it
  // opens, while Core keeps owning the icon markup/click wiring.
  shouldShowIcon?: (context: { onOfferPage: boolean }) => boolean
  // Passed the offer this tag is shown against (if any) and whether it's rendered on that
  // offer's own page, so the modal can link through to the offer and adjust its CTA copy.
  renderModal?: (context: { offer?: App.AnyOffer, onOfferPage: boolean }) => ReactNode
  // Optional: hardcodes the info icon's colour rather than relying on the lab payload's
  // labelPalette (see LuxPlusMonthTakeoverCampaignTagLabel for the matching label text colour).
  iconColour?: 'static-white'
}

/**
 * Per-campaign overrides for the shared campaign tag label, keyed by campaign id.
 * `campaignTag` on the payload is a shared field also consumed by mobile clients, so it must
 * stay plain text — we render our own customised content on web instead of embedding any
 * web-only markup/tokens in that shared string. Add an entry here instead of special-casing a
 * campaign directly in SiteTakeoverCampaignTagLabelCore.
 */
export const SITE_TAKEOVER_CAMPAIGN_TAG_OVERRIDES: Partial<Record<string, SiteTakeoverCampaignTagOverride>> = {
  [LUX_PLUS_MONTH_CAMPAIGN_ID]: {
    renderLabel: () => <LuxPlusMonthTakeoverCampaignTagLabel />,
    shouldShowIcon: () => true,
    renderModal: ({ offer, onOfferPage }) => isTourV2Offer(offer)
      ? <LuxPlusMonthTakeoverToursBenefitModal tourOffer={offer} onOfferPage={onOfferPage} />
      : <LuxPlusMonthTakeoverDetailsModal offer={offer} onOfferPage={onOfferPage} />,
    iconColour: 'static-white',
  },
}
